import React, { useContext, useState } from "react";
import { Box, FormControl, InputLabel, Input } from "@mui/material";
import AppContext from "../../store/app-context";
import styles from "./intro.module.css";

const Intro = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const appCtx = useContext(AppContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("loc");

    appCtx.handleSkipIntro({
      name: data.get("name"),
      phone: data.get("phone"),
      loc: myParam,
    });
  };

  return (
    <div className={styles.intro}>
      <div className={styles["header-intro"]}>
        <div className={styles["header-black-line"]}>Suara Pelanggan</div>
        <div className={styles["header-red-line"]}></div>
        <div className={styles["header-gray-line"]}></div>
      </div>
      <div className={styles.content}>
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <p>Halo, Sahabat Mitsubishi!</p>
          <p>
            Dealer Sardana berkomitmen untuk meningkatkan kualitas pelayanan dan
            kepuasan pelanggan kami, kami mohon kiranya Bapak/Ibu berkenan
            meluangkan waktu mengisi survey suara pelanggan berikut ini:
          </p>
          <FormControl fullWidth variant="standard">
            <InputLabel htmlFor="name">Nama</InputLabel>
            <Input
              id="name"
              name="name"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormControl>
          <FormControl fullWidth variant="standard" sx={{ mt: 1, mb: 4 }}>
            <InputLabel htmlFor="phone">No. Handphone</InputLabel>
            <Input
              id="phone"
              name="phone"
              fullWidth
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </FormControl>
          <p>
            Sebagai bentuk apresiasi kami kepada Bapak/Ibu yang telah meluangkan
            waktu mengisi survey suara pelanggan ini, setiap bulannya kami akan
            memberikan 3 Hadiah menarik kepada 3 pelanggan yang telah memberikan
            Feedback yang dapat membangun kami agar menjadi lebih baik.
          </p>
          <p>Salam Hangat.</p>
          <p>Mitsubishi, Pasti Sardana!</p>
          {name && phone && (
            <button type="submit" className={styles.button}>
              Lanjut
            </button>
          )}
        </Box>
      </div>
    </div>
  );
};

export default Intro;
